// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"57f04736","291":"a9f6044b","377":"6ea2db0c","865":"c4c3519f","935":"6ce1d093"}[chunkId] + ".chunk.js";
};